/**
 * Truncates text to a specified length and adds an ellipsis if the text is longer
 * @param text - The text to truncate
 * @param maxLength - The maximum length of the text before truncation
 * @param ellipsis - The ellipsis character to use (defaults to '...')
 * @returns The truncated text with ellipsis if needed
 */
export const truncateText = (text: string, maxLength: number, ellipsis: string = '...'): string => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + ellipsis;
};

/**
 * Truncates text to a specified length and adds an ellipsis if the text is longer
 * This version preserves whole words
 * @param text - The text to truncate
 * @param maxLength - The maximum length of the text before truncation
 * @param ellipsis - The ellipsis character to use (defaults to '...')
 * @returns The truncated text with ellipsis if needed
 */
const truncateTextPreserveWords = (
  text: string,
  maxLength: number,
  ellipsis: string = '...',
): string => {
  if (!text) return '';
  if (text.length <= maxLength) return text;

  const truncated = text.slice(0, maxLength);
  const lastSpace = truncated.lastIndexOf(' ');

  if (lastSpace === -1) return truncated + ellipsis;
  return truncated.slice(0, lastSpace) + ellipsis;
};
